<div class="sku-generator-container">

    <form class="coverageReportForm">
        <div class="plRegSelection">

            <div class="formControl">
                <label class="formLabel required" for="email">
                    Regions
                </label>

                <div class="toggleCont">
                    <p (click)="openReg()">{{selectedRegions().length ? selectedRegions() : 'Select Region'}}
                    </p>
                    <div class="optionsSet" *ngIf="isRegionOpen">
                        <label for="{{region.regionCode}}" class="optionBtn"
                            [ngClass]="{'checked': selectedRegions().includes(region.regionName)}" *ngFor="let region of regions">
                            <input type="checkbox" [checked]="selectedRegions().includes(region.regionCode)"
                                id="{{region.regionCode}}" (change)="toggleRegionSelection(region.regionName)" />
                            {{ region.regionName }}
                        </label>
                    </div>
                </div>
                <img src="/assets/images/chevron-south.svg" (click)="openReg()" alt="email-icon" class="emailIcon">
            </div>
            <div class="formControl">
                <label class="formLabel required" for="email">
                    Product Line
                </label>
                <div class="toggleCont" [class.disabled]="isPLDisabled">
                    <p (click)="openPL()">{{selectedProductLineIds().length ? selectedProductLineIds() : 'Select
                        Productline'}}</p>
                    <div class="optionsSet" *ngIf="isPLOpen">
                        <label for="{{productLine.code}}" class="optionBtn"
                            [ngClass]="{'checked': selectedProductLineIds().includes(productLine.description)}"
                            *ngFor="let productLine of productLines">
                            <input type="checkbox" [checked]="selectedProductLineIds().includes(productLine.description)"
                                id="{{productLine.code}}" (change)="togglePLSelection(productLine.description)" />
                            {{ productLine.description }}
                        </label>
                    </div>
                </div>
                <img (click)="openPL()" src="/assets/images/chevron-south.svg" alt="email-icon" class="emailIcon">
            </div>
        </div>
        <div class="reqSelectionCont">
            <h3>Select pairing reports to Generate a SKU Report</h3>


            <div class="formControl">
                <label class="formLabel required" for="email">
                    Pairing Request <span>(Select an existing SKU report from dropdown OR Upload New)</span>
                </label>
                <div class="toggleCont" [class.disabled]="isPRDisabled">
                    <p (click)="openPR()"><span
                            *ngIf="selectedPR()">{{selectedPR()?.requestId}}</span>&nbsp;&nbsp;{{selectedPR()?.label
                        || 'Select a pairing request'}}</p>
                    <div class="optionsSet" *ngIf="isPROpen">
                        <label for="{{pairRequest.requestId}}" class="optionBtn" *ngFor="let pairRequest of requstList">
                            <input type="checkbox" id="{{pairRequest.requestId}}"
                                (change)="togglePRSelection(pairRequest.requestId)" />
                            <p><span>{{pairRequest.requestId}}</span>{{ pairRequest.label }}</p>
                        </label>
                    </div>
                </div>
                <img (click)="openPR()" src="/assets/images/chevron-south.svg" alt="email-icon" class="emailIcon"
                    style="top:3rem !important">
                <p class="separater">OR</p>

                <div class="download_file_section">
                    <div>
                        <div class="file_name">Pairing Request Template</div>
                    </div>

                    <div onKeyPress="" (click)="downloadSKUFile()" style="cursor: pointer;">
                        <img class="download-icon" src="../../assets/images/download.svg" alt="download_icon" />
                    </div>
                </div>
                <div class="prUpload" style="border: dashed 1px var(--btn-green) !important;
                        border-radius: 0px !important;
                        background-color: #4db6ac0d !important;">
                    <label for="prFile" class="upload-custom-text" style="color: #4db6ac; font-weight: bolder;">
                        UPLOAD
                    </label>
                    <input type="file" id="prFile" #fileInput name="filename" class="prUploadBtn"
                        (change)="onFileSelected($event)">
                </div>
                <div class="progress_div" *ngIf="isFileUploaded">
                    <div class="progress">
                        <div class="progress-bar active" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100"
                            style="width: 100%"></div>
                    </div>
                    <div>100%</div>
                </div>
                <div class="file_name_div">
                    {{ fileName }}
                </div>
                <div class="file_name_div" *ngIf="getFileSize">
                    <div class="file_size">
                        Size:
                        <span>{{ getFileSize | formatFileSize : true }}</span>
                    </div>
                </div>
                <div class="validation" *ngIf="errorFlag">
                    <img src="../../assets/images/warning.svg" alt="warning-icon" /><span>{{ fileError }}</span>
                </div>

                <div class="success_msg" *ngIf="isFileUploaded">
                    <img src="../../assets/images/sucess-icon.svg" alt="success-icon" width="18px" height="18px" />
                    File uploaded successfully
                </div>
            </div>
        </div>
        <div class="ctaCont">
            <button class="primary" type="button" (click)="reqSubmit()" [disabled]="isSubmitDisabled">
               SUBMIT
            </button>
        </div>
    </form>
<ng-container *ngIf="isSubmitSuccessful">
  <div id="overlay"></div>
  <div class="toster-box">
    <img src="../../assets/images/group-3.svg" width="48px" height="48px" alt="Not Found"
      class="success-icon custom-align" />
    <div class="submitted-message-box">
      <span class="success-text">Submitted Successfully!</span>
      <span class="pairing-id-text">SKU Request Id: {{ pairingId }} </span>
    </div>
    <div class="modal-footer flexSP">
      <button type="button" class="secondary_green_btn" onKeyPress="" (click)="goToHome()" style="float:left">
        Redirect to Home
      </button>&nbsp;&nbsp;&nbsp;&nbsp;
      <button type="button" class="primary_green_btn" onKeyPress="" (click)="goToReports()" style="float:right">
        Go To Reports
      </button>
    </div>
  </div>
</ng-container>
</div>